import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    theme: 'regular',
  },
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { reducer: theme } = themeSlice;

export const { setTheme } = themeSlice.actions;

export const getThemeState = (state) => state.theme;
